module.exports = __webpack_public_path__ + "e27df9bcb405e19efa305ddb9c7ace57.png";